import { useTranslation } from 'react-i18next';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import AuthContext from '../../../Context/AuthContext';
import ServiceStatusContext from '../../../Context/ServiceStatusContext';
import './Navigation.scss';
import Searchbar from '../../../Components/Searchbar/Searchbar';
import ServiceStatusDisplay from '../../../Components/ServiceStatusPopup/ServiceStatusDisplay';
import NotificationDisplay from '../../../Components/NotificationDisplay/NotificationDisplay';

const gT = (t, key) => t(`navigation${key}`);

/* eslint-disable react/prop-types */
export default function Navigation({ isImpersonating }) {
  const { t } = useTranslation('app');
  const [authState] = useContext(AuthContext);
  const history = useHistory();
  const [searchQuery, setSearchQuery] = useState('');
  const [serviceStatusMessages] = useContext(ServiceStatusContext);

  const onSubmit = (e) => {
    history.push(`/app/dashboard/?s=${searchQuery}`);
    e.preventDefault();
  };

  return (
    <div className="navbar-wrapper">
      <Searchbar
        placeholder={gT(t, '.search-client')}
        onChange={(e) => setSearchQuery(e.target.value)}
        onSubmit={onSubmit}
      />
      {serviceStatusMessages.length > 0 && (
        <ServiceStatusDisplay alerts={serviceStatusMessages} />
      )}
      <div className="user-section">
        <NotificationDisplay isImpersonating={isImpersonating} />
        <div className="user-name">
          <p>{authState?.user?.name ?? ''}</p>
        </div>
      </div>
    </div>
  );
}
